<template>
    <body>
    <div id="bgimg-1" class="bgimg-1">
        <div class="caption">
            <span class="border">Your FREE appointments service</span>
        </div>
    </div>

    <div class="features">
        <h3 style="text-align:center;">Let's start...</h3>
        <button v-if="!isRegister" @click="goToProfile">
            <i class="fa fa-user-circle" aria-hidden="true"></i> Create Profile
        </button>
        <button v-else @click="goToAppointment"> New Appointment</button><br>
        <button  class="h_btn" v-if="isRegister" @click.prevent="goToHistory()">Appointments History</button>
        <hr>
        <button class="b_btn" @click="goToBusinessInterface">
            <i class="fa fa-share" aria-hidden="true"></i> &nbsp;<i class="fa fa-briefcase" aria-hidden="true"></i>
            Business Interface
        </button>
    </div>

    <div class="bgimg-2">
        <div class="caption">
            <span class="border" >Choose from many OFFICES</span>
        </div>
    </div>

    <div style="position:relative;">
        <div class="text_msg">
            <p> Push notification from offices available soon.</p>
        </div>
    </div>
    </body>
</template>

<script>
import {getClientProfile} from '../hid.js'
export default {
  name: 'HelloClient',
  props: {
    msg: String,
  },
    data() {
        return {
            isNotRegister:true,
        }
    },
    computed: {
      isRegister() {
          let profile = getClientProfile()
          return profile != null ? true : false
      }
    },
    beforeCreate() {
      /*
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            alert('parallax!')
            // set parallax efect
            let bimg = document.getElementById('bgimg-1')
            console.log(bimg)
            if(!bimg) {
                console.log('null html element')
            }else {
                bimg.style.backgroundAttachment = "fixed"
            }
        }*/
    },
    methods: {
      goToHistory() {
          this.$router.push('/history')
          window.scrollTo(0,0)
      },
      goToProfile() {
          this.$router.push('/profile')
          window.scrollTo(0,0)
      },
        goToAppointment() {
          this.$router.push('/new_appointment')
            window.scrollTo(0,0)
        },
        goToBusinessInterface() {
            //console.log('switch to business UI')
            this.$store.commit('setBusinessUi',!this.$store.getters.getBusiness)
            this.$router.push('/business_signin')
            window.scrollTo(0,0)
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    body, html {
        height: 100%;
        margin: 0;
        font: 400 15px/1.8 "Lato", sans-serif;
        color: #777;
    }

    .bgimg-1, .bgimg-2 {
        position: relative;
        opacity: 0.85;
        background-position: center;
        background-size: cover;
        /* Create the parallax scrolling effect */
        background-attachment: fixed;
        /*background-position: center;*/
        background-repeat: no-repeat;
        /*background-size: cover;*/
    }

    .bgimg-1 {
        background-image: url("https://mdbootstrap.com/img/Photos/Slides/img%20(15).jpg");
        min-height: 100%;
    }

    .bgimg-2 {
        background-image: url("https://mdbootstrap.com/img/Photos/Slides/img%20(6).jpg");
        min-height: 400px;
    }
    .caption {
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        text-align: center;
        color: #000;
    }

    .caption span.border {
        //background-color: black;
        color: #fff;
        padding: 18px;
        font-size: 25px;
        letter-spacing: 10px;
    }
    .features {
        color: #777;
        background-color:white;
        padding:50px 80px;
        text-align: justify;
    }

    h3 {
        letter-spacing: 5px;
        text-transform: uppercase;
        font: 22px "Lato", sans-serif;
        color: #111;
    }
    .text_msg {
        color:#ddd;
        background-color:#282E34;
        padding:50px 80px;
        text-align: justify;
    }

    button {
        background-color: lightseagreen;
        color: white;
        padding: 14px 20px;
        margin: 8px 35%;
        border: none;
        cursor: pointer;
        width: 30%;
        opacity: 0.8;
    }
    button:hover {
        opacity: 1.0;
    }
    .b_btn {
        background-color: dodgerblue;
        color:white;
    }
    .h_btn {
        background-color: darkblue;
        color: white;
    }
    @media screen and (max-width: 600px) {
        .text_msg {
            font-size: 12px;
            padding: 10px 20px;
        }
        .caption {
            top: 80%;
        }
        .caption span.border {
            font-size: 15px;
            color:white;
        }
        h3 {
            font-size: 10px;
        }
        img {
            width: 80%;
            height: 50%;
        }
        button {
            width: 100%;
            margin: 8px 0;
        }
        .b_btn {
            font-size: 12px;
        }

        .bgimg-1 {
            //background-size: 100% 50%;
            //background-image: url("../assets/client_img15_200.jpg");
            background-attachment: scroll;
        }
        .bgimg-2 {
            //background-size: 100% 50%;
            //background-image: url("../assets/client_img6_200.jpg");
            background-attachment: scroll;
        }

        .features {
            padding: 20px 30px;
        }
    }
</style>
